module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9c49ade683c0f0d75796136ff5d1030f.svg";